import React from "react";
import type { SummaryCostEntry, Translate } from "../chatbotManagement.types";
import { formatSummaryCost } from "../chatbotManagement.utils";

interface CostChartProps {
  entries: SummaryCostEntry[];
  t: Translate;
}

const CostChart = ({ entries, t }: CostChartProps): React.ReactElement => {
  const max = Math.max(0, ...entries.map((entry) => entry.cost_usd));

  return (
    <div className="cbm-cost-scroll">
      {entries.length ? (
        entries.map((entry) => {
          const width = max > 0 ? (entry.cost_usd / max) * 100 : 0;
          return (
            <div className="cbm-cost-row" key={entry.restaurant_id || entry.restaurant_name}>
              <div className="cbm-cost-name" title={entry.restaurant_name}>
                {entry.restaurant_name}
              </div>
              <div className="cbm-cost-bar-wrap">
                <div className="cbm-cost-bar-fill" style={{ width: `${width}%` }} />
              </div>
              <div className="cbm-cost-amount">{formatSummaryCost(entry.cost_usd)}</div>
            </div>
          );
        })
      ) : (
        <div className="cbm-empty">{t("admin_chatbot_no_cost")}</div>
      )}
    </div>
  );
};

export default CostChart;
